"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconDownload', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 1C8.55228 1 9 1.44772 9 2V7.58579L10.2929 6.29289C10.6834 5.90237 11.3166 5.90237 11.7071 6.29289C12.0976 6.68342 12.0976 7.31658 11.7071 7.70711L8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071L4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289C4.68342 5.90237 5.31658 5.90237 5.70711 6.29289L7 7.58579V2C7 1.44772 7.44772 1 8 1Z', 'M4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12V14C2 14.5523 2.44772 15 3 15H13C13.5523 15 14 14.5523 14 14V12C14 11.4477 13.5523 11 13 11C12.4477 11 12 11.4477 12 12V13H4V12Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10 1C10.5523 1 11 1.44772 11 2V11.5858L13.2929 9.29289C13.6834 8.90237 14.3166 8.90237 14.7071 9.29289C15.0976 9.68342 15.0976 10.3166 14.7071 10.7071L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L9 11.5858V2C9 1.44772 9.44772 1 10 1Z', 'M5 16C5 15.4477 4.55228 15 4 15C3.44772 15 3 15.4477 3 16V18C3 18.5523 3.44772 19 4 19H16C16.5523 19 17 18.5523 17 18V16C17 15.4477 16.5523 15 16 15C15.4477 15 15 15.4477 15 16V17H5V16Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12 1C12.5523 1 13 1.44772 13 2V14.5858L16.2929 11.2929C16.6834 10.9024 17.3166 10.9024 17.7071 11.2929 18.0976 11.6834 18.0976 12.3166 17.7071 12.7071L12.7071 17.7071C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071L6.29289 12.7071C5.90237 12.3166 5.90237 11.6834 6.29289 11.2929 6.68342 10.9024 7.31658 10.9024 7.70711 11.2929L11 14.5858V2C11 1.44772 11.4477 1 12 1zM6 20C6 19.4477 5.55228 19 5 19 4.44772 19 4 19.4477 4 20V22C4 22.5523 4.44772 23 5 23H19C19.5523 23 20 22.5523 20 22V20C20 19.4477 19.5523 19 19 19 18.4477 19 18 19.4477 18 20V21H6V20z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16 1.00001C16.8284 1.00001 17.5 1.67158 17.5 2.50001V18.818L21.4476 14.9312C22.0379 14.3499 22.9876 14.3573 23.5689 14.9476 24.1501 15.5379 24.1427 16.4876 23.5524 17.0689L17.0524 23.4689C16.4685 24.0437 15.5314 24.0437 14.9476 23.4689L8.44759 17.0689C7.85728 16.4876 7.84992 15.5379 8.43115 14.9476 9.01238 14.3573 9.9621 14.3499 10.5524 14.9312L14.5 18.818V2.50001C14.5 1.67158 15.1716 1.00001 16 1.00001zM8 26.5C8 25.6716 7.32843 25 6.5 25 5.67157 25 5 25.6716 5 26.5V29.5C5 30.3284 5.67157 31 6.5 31H25.5C26.3284 31 27 30.3284 27 29.5V26.5C27 25.6716 26.3284 25 25.5 25 24.6716 25 24 25.6716 24 26.5V28H8V26.5z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;